module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gtULet/tc-custom/9781473817180.jpg?1703704411945",
      "alt": "This image is the cover for the book Period Ship Modelmaking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Period Ship Modelmaking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This new shipmodeller's manual explains in graphic manner how to build a small 1/16th scale model of the American privateer schooner Prince de Neufchatel. She was one of a new class of large, fast and seaworthy schooners that first made their appearance during the war of 1812. She had a short but notoriously successful career that earned her a permanent place in her nation's history. World-renowned ship modeller Phil Reed describes in this new book how to build two versions of this ship: a waterline model and a full-hull display model. Building on the success of his first book, Modelling Sailing Men-of-War, which described the complex building process of the 74-gun ship, he has here taken a simpler vessel, to encourage the less experienced shipwright to embark upon a scratch-built hull. Taking this schooner as a prototype, the author passes on a wealth of experience which will enable modellers of all skill levels to confidently tackle every aspect of building any small fore-and-aft rigged vessel.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Philip Reed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Phil Reed is a professional model maker who has built models for clients in North America and Europe. His work also includes restoration projects for leading galleries and museums. ??After studying Fine Art and Photography he found his true vocation in ship model building, eventually abandoning a teaching career to concentrate full time on his model work. ??His latest work, Building a Miniature Navy Board Model, gives readers a step by step guide to creating these magnificent models.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Seaforth Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0